var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0132 0L9.16607 1.87224L12.0132 3.74448C14.0091 3.74448 15.6329 5.36832 15.6329 7.36414V9.36121L17.5051 11.2334L19.3774 9.36121V7.36414C19.3774 3.3036 16.0738 0 12.0132 0Z",
    fill: "#9EA2E3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0977 1.87224C11.0977 1.14031 11.4355 0.449384 12.0132 0C7.95269 0 4.6491 3.3036 4.6491 7.36414V9.36121L6.52134 11.2334L8.39358 9.36121V7.36414C8.39358 5.36832 10.0174 3.74448 12.0132 3.74448C11.4355 3.2951 11.0977 2.60417 11.0977 1.87224Z",
    fill: "#9EA2E3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0448 9.36133H9.38864V24.0002H20.0448C21.0957 24.0002 21.9477 23.1453 21.9477 22.0907V11.2708C21.9477 10.2162 21.0957 9.36133 20.0448 9.36133Z",
    fill: "#FFCE71"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2915 22.0907V11.2708C11.2915 10.2162 12.1435 9.36133 13.1944 9.36133H3.95522C2.90429 9.36133 2.05231 10.2162 2.05231 11.2708V22.0907C2.05231 23.1453 2.90429 24.0002 3.95522 24.0002H13.1944C12.1435 24.0002 11.2915 23.1453 11.2915 22.0907Z",
    fill: "#FFCE71"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6559 15.7301C14.6559 14.2008 13.3634 12.9735 11.8112 13.0808C10.4813 13.1727 9.41269 14.2648 9.34735 15.5964C9.29008 16.7635 9.98685 17.7751 10.9927 18.1878L10.4532 19.1222C10.169 19.6144 10.5242 20.2296 11.0925 20.2296H12.9075C13.4758 20.2296 13.831 19.6144 13.5468 19.1222L13.0073 18.1878C13.9745 17.7909 14.6559 16.8403 14.6559 15.7301Z",
    fill: "#FC8A3D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.eea818a7af454326c2202e41416af51f.svg";
export { ForwardRef as ReactComponent };